module.exports = __webpack_public_path__ + "img/zixun.12f78e5c.png";